import { createAction, props } from '@ngrx/store';
import { ManualOrder, PagedOrders, OrderFiltersState,  ManualOrderFiltersState, CalculatedOrderRoute, VehicleTypes } from 'src/app/core/manual-services/models/manual-service.models';

export const loadManualServices = createAction(
  '[Manual Services] Load Manual Services',
);

export const loadManualServicesSuccess = createAction(
  '[Manual Services] Load Manual Services Success',
  props<{ orders: PagedOrders }>()
);  

export const loadManualServicesFailure = createAction(
  '[Manual Services] Load Manual Services Failure',
    props<{ error: any }>()
);

 export const loadManualServiceByRiderId = createAction(
    '[Manual Services] Load Manual Orders By Rider Id',
    props<{ rider_id: number, page: number, limit: number, from?: Date, to?: Date }>()
  );

export const updateFilters = createAction(
  '[Manual Service] Update Filters',
    props<{ filters: Partial<OrderFiltersState> }>()
);

export const applyFilters = createAction(
  '[Manual Service] Apply Filters',
  props<{ filters: any }>()
);

export const clearFilters = createAction(
  '[Manual Service] Clear Filters'
);

export const clearOneFilter = createAction(
  '[Manual Service] Clear One Filter',
  props<{ filter: string }>()
);

export const createManualOrder = createAction(
    '[Manual Service] Create Manual Order',
);

export const createManualOrderSuccess = createAction(
    '[Manual Service] Create Manual Order Success',
    props<{ manualOrder: ManualOrder }>()
);

export const createManualOrderFailure = createAction(
    '[Manual Service] Create Manual Order Failure',
    props<{ error: any }>()
);

export const updateManualOrder = createAction(
    '[Manual Service] Update Order',
    props<{ manualOrder: ManualOrder}>()
);

export const calculateManualOrderRoute = createAction(
    '[Manual Service] Calculate Manual Order Route',
);

export const calculateManualOrderRouteSuccess = createAction(
    '[Manual Service] Calculate Manual Order Route Success',
    props<{ calculatedOrderRoute: CalculatedOrderRoute }>()
);

export const calculateManualOrderRouteFailure = createAction(
    '[Manual Service] Calculate Manual Order Route Failure',
    props<{ error: any }>()
);

  export const loadVehicleTypes = createAction(
        '[Manual Service] Load Vehicle Types'
    );

    export const loadVehicleTypesSuccess = createAction(
        '[Manual Service] Load Vehicle Types Success',
        props<{ vehicleTypes: VehicleTypes[] }>()
    );

    export const loadVehicleTypesFailure = createAction(
        '[Manual Service] Load Vehicle Types Failure',
        props<{ error: any }>()
    );

    export const editOrder = createAction(
        '[Order] Edit Manual Service',
    );
    
    export const editOrderSuccess = createAction(
        '[Order] Edit Manual Service Success',
        props<{ manualOrder: ManualOrder }>()
    );
    
    export const editOrderFailure = createAction(
        '[Order] Edit Manual Service Failure',
        props<{ error: string }>()
    );

  export const cancelOrder = createAction(
  '[Order] Cancel Manual Service',
  props<{ order_id: number }>()
  );

  export const cancelOrderSuccess = createAction(
      '[Order] Cancel Manual Service Success',
      props<{ manualOrder: ManualOrder }>()
  );
  
  export const cancelOrderFailure = createAction(
      '[Order] Cancel Manual Service Failure',
      props<{ error: any }>()
  );
  


